<!-- Created by jack on 2022/2/28 - 10:40 -->
<style scoped lang="less">
.main{
  width: 100%;
  border: 0.5px solid #EDEDEE;
  box-sizing: border-box;
  border-radius: 27px;
  display: flex;
  flex-direction: row;

  &__button{
    padding: 8px 0;
    flex:1;
    transition: all ease-in-out 300ms;
    font-family: PingFang SC,serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 12px;
    /* identical to box height, or 100% */
    text-align: center;
    color: #A1A4A9;
    border-radius: 27px;
  }
}
.active{
  font-weight: 500;
  color: #2877FF;
  background: #E9F1FF;
  border: 0.5px solid #2877FF;
}
</style>

<template>
<div class="main">
  <div class="main__button" v-for=" (item,index) of $props.list" :class="{'active': $props.value === item.value }" :key="index" @click="$emit('input',item.value)">
    {{ item.name }}
  </div>
</div>
</template>

<script>
export default {
  props:{
    value:{ type: [String,Number], default: null },
    list:{ type:Array, default: () => ([]) }
  }
}
</script>
